import { Provider, signal } from '@angular/core';
import { MPK_LENTA_B2C_DELIVERY } from '@lentau/mpk/shared/constants';
import { MARKETING_PARTNER_KEY_INJECTION_TOKEN } from '@lentau/mpk/shared/marketing-partner-key.token';

export const MARKETING_PARTNER_KEY_PROVIDER: Provider[] = [
  {
    provide: MARKETING_PARTNER_KEY_INJECTION_TOKEN,
    useFactory: () => signal<string>(MPK_LENTA_B2C_DELIVERY),
  },
];
